import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, message } from 'antd';
import api from '../../../lib/api';
import type { Project, ProjectInput } from '../../../types/project';

type ProjectFormModalProps = {
  open: boolean;
  project: Project | null;
  onCancel: () => void;
  onSaved: () => void;
};

const PRESET_COLORS = ['#1677ff', '#722ed1', '#13c2c2', '#fa8c16', '#52c41a', '#8c8c8c'];

const ProjectFormModal: React.FC<ProjectFormModalProps> = ({ open, project, onCancel, onSaved }) => {
  const [form] = Form.useForm<ProjectInput>();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;

    if (project) {
      form.setFieldsValue({ name: project.name, client: project.client ?? '', color: project.color });
    } else {
      form.setFieldsValue({ name: '', client: '', color: PRESET_COLORS[0] });
    }
  }, [open, project, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    setSaving(true);
    try {
      if (project) {
        await api.projects.update(project.id, values);
      } else {
        await api.projects.create(values);
      }
      onSaved();
    } catch (error) {
      message.error(error instanceof Error ? error.message : '保存失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title={project ? '编辑项目' : '新建项目'}
      okText="保存"
      cancelText="取消"
      confirmLoading={saving}
      onOk={handleOk}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          name="name"
          label="项目名"
          rules={[{ required: true, message: '请填项目名' }]}
        >
          <Input placeholder="例如：客户 A 官网" maxLength={100} />
        </Form.Item>

        <Form.Item name="client" label="客户（可留空）">
          <Input placeholder="例如：客户甲" />
        </Form.Item>

        <Form.Item name="color" label="颜色">
          <Input type="color" style={{ width: 64, padding: 4 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ProjectFormModal;
